import { isValidElement } from 'react';
export const isReactElement = (obj) => {
    return isValidElement(obj);
};
//# sourceMappingURL=isReactElement.js.map